import React from 'react'
import styled from 'styled-components'

const Gutter = ({ space = 3, children }) => {
	return <Wrapper space={space} />
}

const Wrapper = styled.div`
	width: 100%;
	height: ${props => props.space}rem;
`

export default Gutter
